import { useState, useEffect } from 'react';
import styles from './startpage.module.css';


const importAll = async () => {
    const images = import.meta.glob('../../assets/Images/Supporters/*.png');
    const imagePaths = await Promise.all(Object.keys(images).map(async (key) => {
        const module: any = await images[key]();
        return module.default;
    }));
    return imagePaths;
};

export default function Supporters(){
    const [images, setImages] = useState<string[]>([]);

    useEffect(() => {
        const loadImages = async () => {
            const images = await importAll();
            setImages(images);
        };
        loadImages();
    }, []);

    const getFileName = (path: string) => {
        return path.split('/').pop()?.split('.')[0];
    };

    return (
        <div className={styles.grid}>
            {images.map((image, index) => (
                <div key={index} className={styles.supporter}>
                    <img src={image} alt={getFileName(image)} />
                </div>
            ))}
        </div>
    );
};
